import React from 'react'
import TasksContainer from '../../../Components/Applications/Tasks'

export default function Tasks() {
  return (
    <div className='page-body'>
        <TasksContainer/>
    </div>
  )
}
